import { UpdatableModel } from 'projects/common/src/lib/models/updatable-model';

export class LicenseStatusSummary extends UpdatableModel<LicenseStatusSummary> {
  status: string;
  statusLabel: string;
  count: number;
}
